<template>
  <v-container class="ma-0 pa-0">
    <h4 class="mt-12">{{ $t('labels.test-login') }}</h4>
    <div class="row">
      <v-select
        label="Role"
        v-model="role"
        @change="updateUsers"
        :items="roles"
        item-value="key"
        item-text="value"
        class="col-md-6 col-12"
      />
      <v-select
        label="Company"
        v-model="company"
        @change="updateUsers"
        :items="companies"
        item-value="key"
        item-text="value"
        class="col-md-6 col-12"
      />
    </div>
    <v-btn class="btn-label mt-2 action" color="primary" block @click="loginAs('200711042382')">
      {{ $t('dev-buttons.underage') }}
      <template v-slot:loader>
        <span>{{ $t('labels.login-text') }}</span>
      </template>
    </v-btn>

    <v-btn class="btn-label mt-2 action" color="primary" block @click="setPnr()">
      {{ $t('dev-buttons.choose') }}
      <template v-slot:loader>
        <span>{{ $t('labels.login-text') }}</span>
      </template>
    </v-btn>

    <v-btn
      v-for="(fake, idx) in filteredFakes"
      :key="idx"
      class="btn-label mt-2 action"
      color="primary"
      block
      @click="loginAs(`${fake.personalNumber}`)"
    >
      {{ fake.fullName }}<br />
      <small>{{ displayText(fake) }}</small>
      <template v-slot:loader>
        <span>{{ $t('labels.login-text') }}</span>
      </template>
    </v-btn>
  </v-container>
</template>

<script>
import API from '@/services/api'
import {mapActions} from 'vuex'
import Lget from 'lodash/get'
import {CompanyRoles} from '@/components/mixins'

// @group Login
// DevLogins component
export default {
  name: 'DevLogins',

  mixins: [CompanyRoles],

  data: () => ({
    fakes: [],
    filteredFakes: [],
    roles: ['', 'LÄR', 'FTGADM', 'HL', 'YUA', 'BG', 'AVDADM'],
    companies: [],
    role: null,
    company: null
  }),

  mounted() {
    this.getFakes()
  },

  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),

    async setPnr() {
      let res = await this.$dialog.prompt({
        text: 'Ange personnummer',
        title: 'Ange önskat personnummer'
      })

      if (res) {
        this.loginAs(res)
      }
    },

    displayText(p) {
      let t = []
      try {
        if (p.apprenticeships.length) {
          let c = []
          p.apprenticeships.forEach(element => {
            c.push(Lget(element, 'company.name'))
          })
          t.push('LÄR på ' + c.join(', '))
        }
        if (p.employments.length) {
          let r = []
          p.employments.forEach(element => {
            r.push(
              this.getShortRoleDescription(element, Lget(element, 'company.hasDepartments')) +
                ' på ' +
                Lget(element, 'company.name')
            )
          })
          t.push(r.join(', '))
        }
      } catch (e) {
        console.log(e)
      }
      return t.join(';')
    },

    getFakes() {
      API.listFakeLogins().then(res => {
        this.fakes = res.data.rows
        this.getCompanies(res.data.rows)
        this.updateUsers()
      })
    },

    getCompanies(fakes) {
      this.companies = [
        '',
        ...fakes.reduce((acc, fake) => {
          if (fake.apprenticeships.length) {
            fake.apprenticeships.forEach(app => {
              if (!acc.includes(app.company.name)) {
                acc.push(app.company.name)
              }
            })
          }
          if (fake.employments.length) {
            fake.employments.forEach(emp => {
              if (!acc.includes(emp.company.name)) {
                acc.push(emp.company.name)
              }
            })
          }
          return acc
        }, [])
      ]
    },

    loginAs(pnr) {
      API.mobileBankIdLogin({
        personalNumber: pnr
      })
        .then(res => {
          this.setCurrentUser(res.data)
          this.$router.replace({ name: 'Start' })
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.error = err.response.data
          }
        })
    },

    updateUsers() {
      let filteredFakes = this.fakes
      if (this.role) {
        filteredFakes = filteredFakes.filter(fake => {
          if (fake.apprenticeships.length && this.role === 'LÄR') return true
          if (fake.employments.length) {
            return fake.employments.some(emp => {
              const role = this.getShortRoleDescription(emp, Lget(emp, 'company.hasDepartments'))
              return role.includes(this.role)
            })
          }
          return false
        })
      }
      if (this.company) {
        filteredFakes = filteredFakes.filter(fake => {
          if (fake.apprenticeships.length) {
            return fake.apprenticeships.some(app => {
              return this.company === Lget(app, 'company.name')
            })
          }
          if (fake.employments.length) {
            return fake.employments.some(emp => {
              return this.company === Lget(emp, 'company.name')
            })
          }
          return false
        })
      }
      this.filteredFakes = filteredFakes
    }
  }
}
</script>

<style scoped>
span.v-btn__content {
  display: table !important;
  text-align: justify;
}
</style>